import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import themeReducer from "./themeReducer";

import { ObjectsReducer, ObjectTypesReducer, RolesReducer ,UsersRoleReducer, RolesAccessReducer } from "pages/AccessManagement/reducers";

import commonReducer from "./commonReducer";



const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session", "themeState"],
};

const appReducer = combineReducers({
  session: sessionReducer,
  objectsState:ObjectsReducer,
  objectTypesState:ObjectTypesReducer,
  rolesState: RolesReducer,
  commonState: commonReducer,
  usersRoleState :UsersRoleReducer,
  rolesAccessState: RolesAccessReducer,
  themeState: themeReducer
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    state = undefined;
    localStorage.removeItem("token");
    sessionStorage.clear();
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
